import React, { FC } from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import { currency } from '../../../../utils';
import { TABLET } from '../StripeInvoicesTable';
import { getInvoiceBalance } from '../../../../../../Components/InvoiceTool/InvoiceUtil';

const BigScreenTable: FC<any> = ({ invoices }) => {
  return (
    <TableShell>
      <THead>
        <Th>Invoice</Th>
        <Th>Invoice Date</Th>
        <ThRight>Amount</ThRight>
      </THead>
      <TBody>
        {invoices.map((invoice, index) => {
          const _total = getInvoiceBalance(invoice);
          const isOdd = index % 2 === 1;
          return (
            <Tr key={index} $zebra={isOdd}>
              <Td>
                <Mono>{invoice.invoiceNumber}</Mono>
              </Td>
              <Td>{invoice && format(new Date(invoice.invoicedAt), 'yyyy-MM-dd')}</Td>
              <TdRight>
                <PayAmount>{currency(_total)}</PayAmount>
              </TdRight>
            </Tr>
          );
        })}
      </TBody>
    </TableShell>
  );
};

export default BigScreenTable;

const TableShell = styled.div`
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  background: var(--neutral-0);
`;

const gridTemplate = 'minmax(0, 1.6fr) 150px 160px';

const THead = styled.div`
  display: grid;
  grid-template-columns: ${gridTemplate};
  background: var(--table-row-header);
  border-bottom: 1px solid var(--border);
`;

const baseCell = `
  padding: 10px 14px;
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  min-width: 0;
`;

const Th = styled.div`
  ${baseCell}
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--neutral-500);
`;

const ThRight = styled(Th)`
  justify-content: flex-end;
`;

const TBody = styled.div`
  display: flex;
  flex-direction: column;
`;

const Tr = styled.div<{ $zebra?: boolean }>`
  display: grid;
  grid-template-columns: ${gridTemplate};
  background: ${({ $zebra }) => ($zebra ? 'var(--table-row-alt)' : 'var(--table-row-base)')};
  border-bottom: 1px solid var(--border);

  &:last-child {
    border-bottom: 0;
  }
`;

const Td = styled.div`
  ${baseCell}
  color: var(--mainText);
`;

const TdRight = styled.div<{ $muted?: boolean }>`
  ${baseCell}
  justify-content: flex-end;
  font-variant-numeric: tabular-nums;
  color: ${({ $muted }) => ($muted ? 'var(--neutral-600)' : 'var(--mainText)')};
`;

const PayAmount = styled.span`
  font-weight: 700;
  color: var(--success-700, #196a3b);
`;

const Mono = styled.span`
  font-family: 'SFMono-Regular', Menlo, Consolas, monospace;
  font-size: 0.8125rem;
  color: var(--neutral-700);
  background: var(--neutral-100);
  border: 1px solid var(--border);
  padding: 2px 8px;
  border-radius: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;

const NoSmallScreen = styled.div`
  display: contents;
  @media only screen and (max-width: ${TABLET}) {
    display: none;
  }
`;
